/** @format */

import { Component, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';

import { AuthenticationService } from '@shared/authentication/data-access';
import { DynamicListTemplateEnum } from '@shared/favorites/data-access/enums';
import { ListsComponent } from 'libs/my-account/list/templates/src/lib/lists/lists.component';
import { SignedOutDashboardComponent } from 'libs/my-account/list/templates/src/lib/signed-out-dashboard/signed-out-dashboard.component';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
	selector: 'myaccount-list-container',
	templateUrl: './list-container.component.html',
	styleUrl: './list-container.component.scss',
	standalone: false
})
export class ListContainerComponent {
	@ViewChild('templateOutlet', { read: ViewContainerRef, static: false })
	templateOutlet: ViewContainerRef;

	private UNSUBSCRIBE$: Subject<void> = new Subject<void>();
	private dynamicTemplateToLoad = DynamicListTemplateEnum.SIGNED_OUT_DASHBOARD;
	private dynamicComponentRef: ComponentRef<any>;

	constructor(private authenticationService: AuthenticationService) {}

	ngOnInit(): void {
		this.authenticationService
			.getIsAuthenticated$()
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe((isAuthenticated) => {
				this.configureTemplateToLoad(isAuthenticated);
			});
	}

	public configureTemplateToLoad(isAuthenticated: boolean) {
		if (isAuthenticated) {
			this.dynamicTemplateToLoad = DynamicListTemplateEnum.LIST_DASHBOARD;
		} else {
			this.dynamicTemplateToLoad = DynamicListTemplateEnum.SIGNED_OUT_DASHBOARD;
		}

		this.loadDynamicModule(this.dynamicTemplateToLoad);
	}

	/**
	 * @description
	 * Loads a dynamic module by name
	 */
	private loadDynamicModule(componentId: string): void {
		// Check the component ID
		if (componentId === DynamicListTemplateEnum.LIST_DASHBOARD) {
			import('@my-account/list/templates').then(() => {
				// Pass the imported component module in to create the component instance
				this.createDynamicComponent(ListsComponent);
			});
		} else if (componentId === DynamicListTemplateEnum.SIGNED_OUT_DASHBOARD) {
			import('@my-account/list/templates').then(() => {
				// Pass the imported component module in to create the component instance
				this.createDynamicComponent(SignedOutDashboardComponent);
			});
		} else {
			throw new Error(
				`Unknown component ID: ${componentId}.  Unable to render any lazy components.`
			);
		}
	}

	/**
	 * @description
	 * Creates a dynamic component for a given component module
	 */
	private createDynamicComponent(componentType: any) {
		// detroy old template before creating new one
		if (this.dynamicComponentRef) {
			this.dynamicComponentRef.destroy();
		}

		// Create the template component and get its reference
		this.dynamicComponentRef = this.templateOutlet.createComponent(componentType);

		// Start change detection
		this.dynamicComponentRef?.changeDetectorRef.detectChanges();
	}
}
